<div class="about-mentorship-card">
    <h4 class="about-mentorship-card__title">{{ title }}</h4>
    <app-see-more-text
        [text]="text"
        [fontLineHeight]="26"
    ></app-see-more-text>
</div>
